<template>
    <div>
        {{ description }}
        <div v-show="isCustom">
            <strong>
                {{ $filters.date(this.range.start) }}
                - {{ $filters.date(this.range.end) }}
            </strong>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import { OpenDateRange } from '@/type';
import { isPreLossRange, isPostLossRange } from '@/client/client';

export default defineComponent({
  props: {
    dateOfLoss: {
      type: String,
      required: true,
    },
    range: {
      type: Object as () => OpenDateRange,
      required: true,
    },
  },
  computed: {
    isCustom(): boolean {
      return (
        _.isString(this.range.start)
        && _.isString(this.range.end)
      );
    },
    description(): string {
      if (this.isCustom) return 'Custom';
      if (isPreLossRange(this.dateOfLoss, this.range)) return 'Pre Loss';
      if (isPostLossRange(this.dateOfLoss, this.range)) return 'Post Loss';
      return 'All';
    },
  },
});
</script>
